import { render } from "./MiniMap.vue?vue&type=template&id=eb80ab38&scoped=true&ts=true"
import script from "./MiniMap.vue?vue&type=script&lang=ts"
export * from "./MiniMap.vue?vue&type=script&lang=ts"

import "./MiniMap.vue?vue&type=style&index=0&id=eb80ab38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb80ab38"]])

export default __exports__